<template>
  <div class="page-block">
    <header-bar v-if="isLoggedIn">ヘルプ</header-bar>
    <div class="page-block__heading page-block__heading--withbar">
      <h3 class="page-block__title">よくある質問</h3>
    </div>
    <div class="page-block__inner">
      <div>
        "{{ searchedKeyword }}"の検索結果が{{ pagination.total }}件
      </div>
      <div class="faq-search-wrap">
        <div class="faq-search-text">検索</div>
        <input
          v-model="keyword"
          class="faq-search"
          type="search"
          @keydown.prevent.enter="onClickedSearch('enter',$event)">
        <a
          class="c-btn c-btn--search"
          @click.prevent="onClickedSearch('',$event)">
          <img
            src="/img/common/icon-search.png">検索
        </a>
      </div>
      <div
        v-if="pagination.total>0"
        class="faq-serach-area">
        <div
          v-for="item in pagination.data"
          :key="`result${item.id}`"
          class="faq-area-content">
          <h3 class="faq-area-title">
            <p
              class="faq-area-link"
              :data-score="item.score">
              <router-link
                :to="{ name: 'faq-detail', params: { id: item.id } }"
                class="c-text-link">
                {{ item.title }}
              </router-link>
            </p>
          </h3>
          <div class="faq-area-category">
            よくある質問 > {{ item.category.title }}
          </div>
          <div class="faq-area-abstract">
            {{ stripTag(item.content) }}
          </div>
        </div>
      </div>
      <div
        v-else
        class="faq-serach-area">
        「{{ searchedKeyword }}」の結果がありません<br />
        別のキーワードで検索してみてください。
      </div>
    </div>
    <div class="pager">
      <div
        v-if="pagination.data"
        class="pager">
        <pagination
          :pagination="pagination"
          @on-pagination-clicked="onPaginationClicked">
        </pagination>
      </div>
      <div
        class="c-btn-wrap c-btn-wrap-faq">
        <router-link
          :to="{ name: 'faq' }"
          class="c-btn c-btn--back">
          よくある質問へ戻る
          <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HeaderBar from '../HeaderBar'
import Pagination from '../../../components/Pagination'

export default {
  components: {
    HeaderBar,
    Pagination,
  },
  data() {
    return {
      items: [],
      keyword: '',
      searchedKeyword: '',
      pagination: {},
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
  },
  mounted() {
    this.keyword = this.$route.query.keyword
    this.searchedKeyword = this.keyword
    this.fetchItems(this.$route.query.page)
  },
  methods: {
    async fetchItems(page = 1) {
      if (this.keyword) {
        const { data } = await window.axios.get(`/api/client/faqs/search/?keyword=${this.keyword}&page=${page}`)
        this.searchedKeyword = this.keyword
        this.pagination = data
      } else {
        this.$router.push({ name: 'faq' })
      }
    },
    async fetchKeywordSearch(page = 1) {
      this.$router.push({
        name: 'faq-search',
        query: {
          page,
          keyword: this.keyword,
        },
      })
      this.fetchItems(page)
    },
    onClickedSearch(type, event) {
      if (type === 'enter' && event.keyCode !== 13) return
      this.fetchKeywordSearch(1)
    },
    onPaginationClicked(page) {
      this.fetchKeywordSearch(page)
    },
    stripTag(value) {
      return value.toString().replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, '')
    },
  },
}

</script>

<style scoped>
.faq-serach-area{
  .faq-area-title{
    @include min{
      font-size: 16px;
    }
    @include max{
      font-size: 85%;
    }
  }
  .faq-area-link {
    display: block;
  }
}
</style>
